import { computeVatNumber } from '@features/companies/utils/computeVatNumber'
import { isFrenchCompany } from '@features/companies/utils/isFrenchCompany'
import { Company, FrenchCompany } from '@modules-deprecated/app/companies/types'
import { getCompanyName } from '@modules-deprecated/app/companies/utils/getCompanyName'

import { OnboardingForm } from '../../../../../types/onboardingForm'

export const getCompanyDetails = (company: Partial<Company> | Partial<FrenchCompany>): OnboardingForm['company'] => {
  if (isFrenchCompany(company)) {
    return {
      city: company.city ?? '',
      legalStatus: company.legalForm ?? undefined,
      name: getCompanyName(company) ?? '',
      registrationNo: company.siret ?? '',
      street: company.street ?? '',
      vatNo: computeVatNumber('FR', company.siret) ?? '',
      zipcode: company.zipcode ?? '',
    }
  }

  return {
    city: company.city ?? '',
    name: getCompanyName(company) ?? '',
    registrationNo: company.id ?? '',
    street: [company.street, company.number].filter(Boolean).join(' '),
    zipcode: company.zipcode ?? '',
  }
}
